import { nl2ul } from "../helper/common";
import SkorAi2 from "../assets/img/skorAI_logo2.gif";
import useTranslator from "../hooks/useTranslator";
import CancelIcon from "../assets/img/cancel-01.svg";

const Summary = (props) => {
  const { _t } = useTranslator();
  const { user, showReportIcons, setShowChatBot, llShowOnly, isShowOnMobile, isOpen, setIsOpen } =
    props;
  return (
    showReportIcons && llShowOnly && isOpen && (
        <div
          class={`wrapper-modal`}
          onClick={() => setIsOpen(false)}
        >
          <div className="profile-summary-wrapper">
            <div
              className="main_summary mainSummaryWrapper"
              style={{position: "relative"}}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="cursor-pointer" onClick={() => setIsOpen(false)}>
                <img
                  src={CancelIcon}
                  alt="icon"
                  className="canceicon topRightIcon"
                />
              </div>
              <h5 className="modal-head-summary">{_t("profileSummary")}</h5>
              <div className="modal-body">
                <div className="summary_content">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: nl2ul(
                        localStorage.getItem("i18nextLng") === "es"
                          ? user?.profileSummaryEs
                          : user?.profileSummary,
                        "two-column-list"
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="disclaimer_div">
                <p>
                  <strong>{_t("disclaimer")}:</strong>
                  {_t(
                    "summaryGeneratedByAiThroughSkorAiDataInformationMayBeProneToError",
                    "Disclaimer text"
                  )}
                </p>
              </div>
              {user?.about_me && (
                <div>
                  <h5 className="modal-head-summary tenant-input-content">
                    {_t("tenantInputContext")}
                  </h5>
                  <div className="summary_content">
                    <p className="summary_content_para"> {user?.about_me}</p>
                  </div>
                </div>
              )}

              <div
                onClick={() => {
                  setIsOpen(false)
                  setShowChatBot(true)
                }}
                className="d-flex items-center justify-content-end cursor-pointer"
              >
                <img
                  className="Skor_ai_logo flex-shrink-0"
                  src={SkorAi2}
                  alt="Vector Icon"
                />
              </div>
            </div>
          </div>
        </div>
    )
  );
};

export default Summary;
